import { Component, OnInit, AfterViewInit, TemplateRef, ViewChild, Input } from '@angular/core';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv'
import { ModalDirective } from 'ngx-bootstrap/modal';
import { MessageSeverity, DialogType, AlertService } from '../../../services/alert.service';
import { User } from '../../../models/user.model';
import { UserEdit } from '../../../models/user-edit.model';
import { Role } from '../../../models/role.model';
import { AppTranslationService } from '../../../services/app-translation.service';
import { AccountService } from '../../../services/account.service';
import { UserInfoComponent } from '../../controls/user-info.component';
import { Utilities } from '../../../services/utilities';
import { Permission } from '../../../models/permission.model';
import Error = MessageSeverity.Error;
import Error1 = MessageSeverity.Error;
import Confirm = DialogType.Confirm;
import Prompt = DialogType.Prompt;
import { Router } from '@angular/router';
import { UserEditorComponent } from './user-editor/user-editor.component';
import { DisplayModes } from '../../../models/enums';
import { AppConfigService } from '../../../app.config';
import { ProvisionUsersComponent } from './provision-users/provision-users.component';
import Success = MessageSeverity.Success;
import { saveAs } from 'file-saver';
import { EquipmentTypeService } from '../../../release-form/services/equipment-type.service';
import { UserCentreBricksService } from './user-centre-bricks/user-centre-bricks.service';

@Component({
  selector: 'users-management',
  templateUrl: './users-management.component.html',
  styleUrls: ['./users-management.component.css']
})
export class UsersManagementComponent implements OnInit, AfterViewInit {
  columns: any[] = [];
  rows: User[] = [];
  rowsCache: User[] = [];
  editedUser: UserEdit;
  sourceUser: UserEdit;
  searchText: string;
  pageSize: number = 0;
  editingUserName: { name: string };
  loadingIndicator: boolean;
  displayMode: DisplayModes = DisplayModes.Success;
  allRoles: Role[] = [];
  public logo = require("../../../assets/images/demo/Icon_Users Managements.png");

  @ViewChild('indexTemplate')
  indexTemplate: TemplateRef<any>;

  @ViewChild('userNameTemplate')
  userNameTemplate: TemplateRef<any>;

  @ViewChild('rolesTemplate')
  rolesTemplate: TemplateRef<any>;

  @ViewChild('actionsTemplate')
  actionsTemplate: TemplateRef<any>;

  @ViewChild('editorModal')
  editorModal: ModalDirective;

  @ViewChild('userEditor')
  userEditor: UserEditorComponent;

  @ViewChild("provisionModal")
  provisionModal: ModalDirective;

  @ViewChild("provisionUsers")
  provisionUsers: ProvisionUsersComponent;

  @ViewChild("workingDaysModal")
  workingDaysModal: ModalDirective;

  @ViewChild("centreBricksModal")
  centreBricksModal: ModalDirective;
  centreBricksUser: UserEdit;
  /** managers (job business unit with units under it) → number of open centre bricks set on them */
  centreCounts: { [userId: number]: number } = {};

  @ViewChild("equipmentModal")
  equipmentModal: ModalDirective;

  @ViewChild("rolesModal")
  rolesModal: ModalDirective;

  @ViewChild("equipmentUploadModal")
  equipmentUploadModal: ModalDirective;

  /** Equipment bulk upload: the last result (updated users, equipment, errors) or the request's error. */
  equipmentResult: { updatedUsers: number, equipmentCount: number, errors: string[] } = null;
  equipmentUploadError: string = null;
  equipmentUploading = false;

  /** User whose roles the roles popup lists (shown when they have more than one). */
  rolesUser: User;

  /** User whose equipment the equipment popup lists. */
  equipmentUser: User;

  /** User whose working days (inherited, or their exception) the working days modal shows. */
  workingDaysUser: UserEdit;

  displayFilter: any[] = [
    { label: 'Total', value: 1 },
    { label: 'Active', value: 2 },
    { label: 'In Active', value: 3 }];
  display = this.displayFilter.filter(x => x.value == 1)[0];

  csvOptions = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    showTitle: true,
    title: 'User List :',
    useBom: true,
    noDownload: false,
    // every column of the table and every field of the user form (GPS Enabled removed, Full Sales Dashboard hidden)
    headers: ["ID", "User Name", "Full Name", "Email", "Phone Number", "HR Code", "Business Unit", "Job", "Roles", "Hiring Date", "Creation Date",
      "Last Web Login", "Last Mobile Login", "Enabled", "Disabled Date", "Locked Out", "Has Car", "Car License No", "Equipment"]

  };
  selectedUserId;
  addNew: boolean = false;
  jobMode: boolean = false;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;

  constructor(private readonly alertService: AlertService,
    private readonly translationService: AppTranslationService,
    private readonly appConfig: AppConfigService,
    private readonly accountService: AccountService,
    private readonly router: Router,
    private readonly equipmentTypeService: EquipmentTypeService,
    private readonly userCentreBricksService: UserCentreBricksService) {
    this.pageSize = this.appConfig.settings.pageSize;
    this.columns = [

      { field: 'userName', header: this.translationService.getTranslation("users.userName") },
      { field: 'fullName', header: this.translationService.getTranslation("users.fullName") },
      { field: 'hrCode', header: this.translationService.getTranslation("users.hrCode") },
      { field: 'businessUnitName', header: this.translationService.getTranslation("users.businessUnit") },
      { field: 'jobName', header: this.translationService.getTranslation("users.jobPosition") },
      { field: 'email', header: this.translationService.getTranslation("users.email") },
      { field: 'phoneNumber', header: this.translationService.getTranslation("users.phoneNumber") },
      { field: 'roleNames', header: this.translationService.getTranslation("users.roles") },
      { field: 'hiringDate', header: this.translationService.getTranslation("users.hiringDate") },
      { field: 'creationDate', header: this.translationService.getTranslation("users.creationDate") },
      { field: 'lastWebLoginDate', header: this.translationService.getTranslation("users.lastWebLogin") },
      { field: 'lastMobileLoginDate', header: this.translationService.getTranslation("users.lastMobileLogin") },
      { field: 'carLicenseNo', header: this.translationService.getTranslation("users.carLicenseNo") },
      { field: 'equipmentCount', header: this.translationService.getTranslation("users.equipment") }

    ];
    this.displayFilter = [
      { label: this.translationService.getTranslation("users.total"), value: 1 },
      { label: this.translationService.getTranslation("users.active"), value: 2 },
      { label: this.translationService.getTranslation("users.inActive"), value: 3 }];
    this.display = this.displayFilter.filter(x => x.value == 1)[0];

    setTimeout(() => {
      this.loadData();
    });
  }


  ngOnInit() {

    let gT = (key: string) => this.translationService.getTranslation(key);



  }


  ngAfterViewInit() {


  }
  showProvisionModal() {
    this.provisionModal.show();
  }

  addNewUserToList() {
    if (this.sourceUser) {
      Object.assign(this.sourceUser, this.editedUser);

      let sourceIndex = this.rowsCache.indexOf(this.sourceUser, 0);
      if (sourceIndex > -1)
        Utilities.moveArrayItem(this.rowsCache, sourceIndex, 0);

      sourceIndex = this.rows.indexOf(this.sourceUser, 0);
      if (sourceIndex > -1)
        Utilities.moveArrayItem(this.rows, sourceIndex, 0);

      this.editedUser = null;
      this.sourceUser = null;
    }
    else {
      let user = new User();
      Object.assign(user, this.editedUser);
      this.editedUser = null;

      let maxIndex = 0;
      for (let u of this.rowsCache) {
        if ((<any>u).index > maxIndex)
          maxIndex = (<any>u).index;
      }

      (<any>user).index = maxIndex + 1;

      this.rowsCache.splice(0, 0, user);
      this.rows.splice(0, 0, user);
      this.rows = [...this.rows];
    }
  }

  resetPassword(userid) {
    this.alertService.startLoadingMessage();
    this.loadingIndicator = true;
    this.accountService.resetPassword(userid).subscribe(
      () => {
        this.alertService.stopLoadingMessage();
        this.alertService.showMessage("Password Reset", "A password reset link has been emailed to the user. They can use it to set their own new password.", MessageSeverity.Success);
      },
      error => {
        this.alertService.stopLoadingMessage();
        this.alertService.showStickyMessage("Password Reset Failed", error, MessageSeverity.Error);
      });
    this.loadData();
  }

  forceLogoutUser(userId) {
    this.alertService.showDialog(
      "Are you sure you want to force logout this user? Their current session will end immediately, even if their access token hasn't expired yet.",
      Confirm,
      () => {
        this.alertService.startLoadingMessage("Forcing logout...");
        this.accountService.forceLogoutUser(userId).subscribe(
          () => {
            this.alertService.stopLoadingMessage();
            this.alertService.showMessage("Success", "The user has been logged out.", MessageSeverity.Success);
          },
          error => {
            this.alertService.stopLoadingMessage();
            this.alertService.showStickyMessage("Force Logout Failed", error, MessageSeverity.Error);
          });
      });
  }

  forceLogoutAll() {
    const confirmPhrase = "LOGOUT ALL";
    this.alertService.showDialog(
      `This will immediately log out EVERY signed-in user, including yourself. Type "${confirmPhrase}" (without quotes) to confirm.`,
      Prompt,
      (typedValue: string) => {
        if ((typedValue || "").trim() !== confirmPhrase) {
          this.alertService.showMessage("Cancelled", `Confirmation text didn't match "${confirmPhrase}" — nothing was done.`, MessageSeverity.Warn);
          return;
        }
        this.alertService.startLoadingMessage("Logging out all users...");
        this.accountService.forceLogoutAll().subscribe(
          () => {
            this.alertService.stopLoadingMessage();
            this.alertService.showMessage("Success", "All users have been logged out.", MessageSeverity.Success);
          },
          error => {
            this.alertService.stopLoadingMessage();
            this.alertService.showStickyMessage("Force Logout Failed", error, MessageSeverity.Error);
          });
      });
  }

  onProvisionModalHidden() {
    this.loadData();
  }

  loadData() {
    this.loadCentreCounts();
    this.alertService.startLoadingMessage();
    this.loadingIndicator = true;

    if (this.canViewRoles) {
      this.accountService.getUsersAndRoles().subscribe(results => this.onDataLoadSuccessful(results[0], results[1]), error => this.onDataLoadFailed(error));
    }
    else {
      this.accountService.getUsers().subscribe(users => this.onDataLoadSuccessful(users, this.accountService.currentUser.roles.map(x => new Role(x))), error => this.onDataLoadFailed(error));
    }
  }


  onDataLoadSuccessful(users: User[], roles: Role[]) {
    this.alertService.stopLoadingMessage();
    this.loadingIndicator = false;

    users.forEach((user, index, users) => {
      (<any>user).index = index + 1;
      (<any>user).equipmentCount = (user.equipments || []).length;   // sortable Equipment column
      (<any>user).roleNames = (user.roles || []).map((r: any) => r.name || r).join(', ');   // sortable Roles column
    });

    this.rowsCache = [...users];
    this.rows = users;

    this.allRoles = roles;
    if (this.searchText)
    this.rows = this.rowsCache.filter(r => Utilities.searchArray(this.searchText, false, r.userName, r.fullName, r.hrCode, r.email, r.phoneNumber, r.jobTitle, (<any>r).roleNames));
  }


  onDataLoadFailed(error: any) {
    this.alertService.stopLoadingMessage();
    this.loadingIndicator = false;

    //this.alertService.showStickyMessage("Load Error", `Unable to retrieve users from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
    //  Error, error);
  }


  onSearchChanged(value: string) {

    this.rows = this.rowsCache.filter(r => Utilities.searchArray(this.searchText, false, r.userName, r.fullName, r.hrCode, r.email, r.phoneNumber, r.jobTitle, (<any>r).roleNames));
  }

  onChangeActiveFilter() {
    if (this.display.value == 1)
      this.rows = this.rowsCache;
    else if (this.display.value == 2)
      this.rows = this.rowsCache.filter(r => Utilities.searchArray('true', false, r.isEnabled));

    else if (this.display.value == 3)
      this.rows = this.rowsCache.filter(r => Utilities.searchArray('false', false, r.isEnabled));

  }

  onEditorModalHidden() {
    this.editingUserName = null;
    this.userEditor.resetForm(true);
  }


  newUser() {
    this.editingUserName = null;
    this.sourceUser = null;
    //this.editedUser = this.userEditor.newUser(this.allRoles);
    this.addNew = true;

    //   this.editorModal.show();
  }


  editUser(row: UserEdit) {
    //this.editingUserName = { name: row.userName };
    //this.sourceUser = row;
    //this.editedUser = this.userEditor.editUser(row, this.allRoles);
    //this.editorModal.show();

    this.selectedUserId = row.id;
    this.addNew = true;

  }


  deleteUser(row: UserEdit) {
    this.selectedUserId = row;
    this.deleteModal.show();
  }


  deleteUserHelper() {
    this.hideDeleteModal();
    this.alertService.startLoadingMessage("Deleting...");
    this.loadingIndicator = true;

    this.accountService.deleteUser(this.selectedUserId.id)
      .subscribe(results => {
        this.alertService.stopLoadingMessage();
        this.loadingIndicator = false;

        this.rowsCache = this.rowsCache.filter(item => item !== this.selectedUserId)
        this.rows = this.rows.filter(item => item !== this.selectedUserId)
      },
        error => {
          this.alertService.stopLoadingMessage();
          this.loadingIndicator = false;

          //this.alertService.showStickyMessage("Delete Error", `An error occured whilst deleting the user.\r\nError: "${Utilities.getHttpResponseMessage(error)}"`,
          //  Error1, error);
        });
  }

  userJobs(row: UserEdit) {
    this.selectedUserId = row.id;
    this.jobMode = true;
    //this.router.navigate(['user-jobs', row.id]);

  }

  get canAssignRoles() {
    return this.accountService.userHasPermission(Permission.assignRolesPermission);
  }

  get canViewRoles() {
    return this.accountService.userHasPermission(Permission.viewRolesPermission)
  }

  get canManageUsers() {
    return this.accountService.userHasPermission(Permission.manageUsersPermission);
  }

  get canViewWorkingDays() {
    return this.accountService.userHasPermission(Permission.viewWorkingDaysPermission) || this.canManageWorkingDays;
  }

  get canManageWorkingDays() {
    return this.accountService.userHasPermission(Permission.manageWorkingDaysPermission);
  }

  // nobody sets working day exceptions on themselves (governance); the server refuses it too
  get canEditWorkingDaysUser() {
    return this.canManageWorkingDays && this.workingDaysUser && String(this.workingDaysUser.id) !== String(this.accountService.currentUser.id);
  }

  private loadCentreCounts() {
    if (!this.canManageUsers) return;
    this.userCentreBricksService.managers().subscribe(list => {
      const counts = {};
      (list || []).forEach(x => counts[x.userId] = x.openCount);
      this.centreCounts = counts;
    });
  }

  isManager(user: any): boolean { return this.centreCounts.hasOwnProperty(+user.id); }
  centreCount(user: any): number { return this.centreCounts[+user.id] || 0; }

  userCentreBricks(row: UserEdit) {
    this.centreBricksUser = row;
    this.centreBricksModal.show();
  }

  userWorkingDays(row: UserEdit) {
    this.workingDaysUser = row;
    this.workingDaysModal.show();
  }

  get canControlAuthentication() {
    return this.accountService.userHasPermission(Permission.authenticationControlPermission);
  }

  /** The roles arrive as role objects (name, description) although the model types them as strings. */
  firstRole(user: User): string {
    const role: any = user.roles && user.roles[0];
    return role ? (role.name || role) : '';
  }

  showEquipmentUpload() {
    this.equipmentResult = null;
    this.equipmentUploadError = null;
    this.equipmentUploadModal.show();
  }

  onEquipmentUploadHidden() {
    // the Equipment column shows the new counts
    if (this.equipmentResult && this.equipmentResult.updatedUsers)
      this.loadData();
  }

  downloadEquipmentTemplate() {
    this.equipmentTypeService.DownloadUsersTemplate().subscribe(blob => {
      saveAs(blob as Blob, 'Users equipment.csv');
    }, () => this.equipmentUploadError = 'The template could not be downloaded.');
  }

  uploadEquipment(input: HTMLInputElement) {
    const file = input.files && input.files[0];
    input.value = '';
    if (!file)
      return;
    this.equipmentResult = null;
    this.equipmentUploadError = null;
    this.equipmentUploading = true;
    this.equipmentTypeService.UploadUsers(file).subscribe(result => {
      this.equipmentUploading = false;
      this.equipmentResult = result as any;
    }, err => {
      this.equipmentUploading = false;
      const body = err && err.error;
      const reason = body && (body.Message || body.message || (typeof body === 'string' && body.length < 500 ? body : null));
      // never hide why: the server's reason, else the HTTP status (0 = no answer from the server)
      this.equipmentUploadError = reason
        || `The sheet could not be uploaded (HTTP ${err ? err.status : '?'}${err && err.status === 0 ? ': no answer from the server' : (err && err.statusText ? ': ' + err.statusText : '')}).`;
      console.error('Equipment bulk upload failed', err);
    });
  }

  downloadEquipmentErrors() {
    const text = '\uFEFF' + (this.equipmentResult.errors || []).join('\r\n');
    saveAs(new Blob([text], { type: 'text/csv;charset=utf-8' }), 'Users equipment errors.csv');
  }

  showRoles(user: User) {
    this.rolesUser = user;
    this.rolesModal.show();
  }

  showEquipment(user: User) {
    this.equipmentUser = user;
    this.equipmentModal.show();
  }

  downloadCSV() {
    const yesNo = (value: boolean) => value ? 'Yes' : 'No';
    const csvData = this.rows.map(o => {
      return {
        id: o.id, userName: o.userName, fullName: o.fullName || '', email: o.email || '', phoneNumber: o.phoneNumber || '', hrCode: o.hrCode || '',
        businessUnitName: o.businessUnitName || '', jobName: o.jobName || '', roles: (o.roles || []).map((r: any) => r.name || r).join(' | '),
        hiringDate: this.csvDate(o.hiringDate), creationDate: this.csvDate(o.creationDate),
        lastWebLoginDate: this.csvDate(o.lastWebLoginDate, true), lastMobileLoginDate: this.csvDate(o.lastMobileLoginDate, true),
        isEnabled: yesNo(o.isEnabled), disabledDate: o.isEnabled ? '' : this.csvDate(o.disabledDate), isLockedOut: yesNo(o.isLockedOut),
        hasCar: yesNo(o.hasCar), carLicenseNo: o.carLicenseNo || '',
        // EquipmentType(serial number), several separated by |
        equipment: (o.equipments || []).map(e => `${e.equipmentTypeName}(${e.serialNumber})`).join(' | ')
      };

    });
    new AngularCsv(csvData, "UsersList", this.csvOptions);
  }

  private csvDate(value: any, withTime = false): string {
    if (!value)
      return '';
    const d = new Date(value);
    if (isNaN(d.getTime()))
      return '';
    const pad = (n: number) => (n < 10 ? '0' : '') + n;
    const date = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
    return withTime ? `${date} ${pad(d.getHours())}:${pad(d.getMinutes())}` : date;
  }

  closeAdding(event) {
    this.selectedUserId = undefined;
    this.addNew = false;
    this.jobMode = false;
    if (event) {
      this.loadData();
    }
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }
}
